import { Form, Row, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, useLocation } from 'react-router-dom'

import { LoginButton, StyledInput, LoginContentContainer } from '../components'
import { useChangePassword } from '../hooks'

const ChangePassword = () => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const token = new URLSearchParams(search).get('token')

  const { changePassword, isLoading } = useChangePassword()

  const handleChangePassword = (values: { password: string }) => {
    const { password } = values
    if (token) {
      changePassword({ password, token })
    }
  }

  return token ? (
    <Spin spinning={isLoading}>
      <LoginContentContainer>
        <Form
          name="recover_pass"
          initialValues={{ remember: true }}
          onFinish={handleChangePassword}
          style={{ width: '100%' }}
        >
          <Form.Item
            name="password"
            rules={[
              { required: true, message: t('login.enter_password') },
              {
                min: 8,
                message: t('login.password_min_length'),
              },
            ]}
          >
            <StyledInput type="password" placeholder={t('login.new_password')} />
          </Form.Item>

          <Form.Item
            name="passwordConfirm"
            rules={[
              {
                required: true,
                message: t('login.confirm_password_validation'),
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error(t('login.password_match_error')))
                },
              }),
            ]}
          >
            <StyledInput type="password" placeholder={t('login.confirm_password')} />
          </Form.Item>
          <Form.Item>
            <Row justify="center">
              <LoginButton type="primary" htmlType="submit" size="large">
                {t('login.change_password')}
              </LoginButton>
            </Row>
          </Form.Item>
        </Form>
      </LoginContentContainer>
    </Spin>
  ) : (
    <Route element={<Navigate to="/login" />} />
  )
}

export { ChangePassword }
